/**
 * Check if a given object implements the SelfLearningUnitFilter interface.
 */
export function instanceOfSelfLearningUnitFilter(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
export function SelfLearningUnitFilterFromJSON(json) {
    return SelfLearningUnitFilterFromJSONTyped(json, false);
}
export function SelfLearningUnitFilterFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'value': json['value'],
    };
}
export function SelfLearningUnitFilterToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'value': value.value,
    };
}
